import React, {useState}  from 'react'
import { ListItem, ListItemText, ListItemIcon, ListItemButton, Grid, Button,
            TextField, Tooltip } from "@mui/material";
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import RefreshIcon from '@mui/icons-material/Refresh';
import AddIcon from '@mui/icons-material/Add';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
// import { set } from 'system-runtime/src/state';

export default function Favorites(props) {
    var favs = props.favorites
    const [editIndex, setEditIndex] = useState(-1)

    // var menu = <Menu
    //     open = {contextIndex>=0}
    //     onClose = {() => setContextIndex(-1)}
    //     >
    //         <MenuItem>Add...</MenuItem>
    // </Menu>

    var favList = favs.map( (F, index) => 
        <ListItem key={index} selected={F.used} onBlur={() => setEditIndex(-1)}>
            <ListItemText                          
                            onContextMenu={(e) => {e.preventDefault();  props.favsClicked(index)}}
                            onDoubleClick={() => setEditIndex(index)}
            >
                <Grid container>
                    <Grid item xs={6}>
                        {index==editIndex ? 
                        <TextField value={F.name}  onChange={(e) => {props.changeFavName(index, e)}}/>
                        :
                        F.name
                    }
                    </Grid>
                    <Grid item xs={4}>
                        {index == editIndex ?
                        <TextField value={F.sum} onChange={(e) => {props.changeFavSum(index, e)}}/>
                        :
                        F.sum
                    }
                    </Grid>
                    <Grid item xs={1}/>
                    <Grid item xs={1}>
                        <Button onClick={() =>{
                            props.deleteFav(index)}
                        }>
                        <DeleteIcon/>
                        </Button>
                        </Grid>
                </Grid>
                </ListItemText>
        </ListItem>    
    )
    var buttons = 
    <Grid container>
        <Grid item xs={4} onClick={() => {props.addAllFavs(); setEditIndex(-1)}}>
            <Button><Tooltip title={"Add all"}><SendIcon/></Tooltip></Button>
        </Grid>
        <Grid item xs={4} onClick={() => {props.addFav();setEditIndex(-1)}}>
            <Button><Tooltip title="Add"><AddIcon/></Tooltip></Button>
            </Grid>
        <Grid item xs={4} onClick={() => {props.refreshAllFavs(); setEditIndex(-1)}}>
            <Button> <Tooltip title={"Refresh"}><RefreshIcon/></Tooltip></Button>
            </Grid>
    </Grid>

    return(
        <div>
            [Favorites]={favs.length}
            {favList}
            {buttons}
            {/* {menu} */}
        </div>
    )
}